import * as React from 'react';
import { Modal } from '@beehive/components';
import _ from 'lodash';

import messages from 'messages';
import PropTypes from 'prop-types';

export interface ModalConfig {
  prefixCls?: string;
  className?: string;
  visible?: boolean;
  title?: React.ReactNode;
  content?: React.ReactNode;
  onOk?: (...args: any[]) => any | PromiseLike<any>;
  onCancel?: (...args: any[]) => any | PromiseLike<any>;
  centered?: boolean;
  width?: string | number;
  iconClassName?: string;
  okText?: string;
  okType?: string;
  cancelType?: string;
  cancelText?: string;
  iconType?: string;
  maskClosable?: boolean;
  zIndex?: number;
  okCancel?: boolean;
  style?: React.CSSProperties;
  type?: string;
  keyboard?: boolean;
  getContainer?: (instance: React.ReactInstance) => HTMLElement;
}

interface ModayAny {
  [key: string]: any;
}

export interface ModalTipProps extends ModayAny {
  modalType?: 'info' | 'success' | 'error' | 'warning' | 'confirm';
  modalConfig: ModalConfig;
  componentClass: string | keyof React.ReactHTML | React.ComponentType<any>;
}

class ModalTip extends React.Component<ModalTipProps, any> {

  public static contextTypes = {
    intl: PropTypes.object,
  };

  public static defaultProps = {
    modalType: 'confirm',
    modalConfig: {},
  };

  private handleClick = (event: React.MouseEvent<HTMLElement>) => {
    const { intl } = this.context;
    const { modalType = 'confirm', modalConfig } = this.props;
    if (event.stopPropagation) {
      event.stopPropagation();
    }
    if (Modal[modalType]) {
      Modal[modalType]({
        okText: intl.formatMessage(messages.okText),
        cancelText: intl.formatMessage(messages.cancelText),
        ...modalConfig,
      });
    }
  }

  public render() {
    const {
      children,
      componentClass,
      ...others
    } = this.props;

    const otherProps = _.omit(others, ['modalConfig', 'modalType']);

    return React.createElement(
      componentClass,
      {
        onClick: this.handleClick,
        ...otherProps,
      },
      children,
    );
  }
}

export default ModalTip;
